<template>
  <div class="base-loader">
    <ClientOnly v-if="isLogo">
      <Vue3Lottie
        animation-link="/logo-loader.json"
        :height="size"
        :width="size"
      />
    </ClientOnly>
    <svg
      v-else
      class="base-loader__circle"
      :width="size"
      :height="size"
      viewBox="0 0 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="base-loader__circle-path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        :stroke-width="strokeWidth"
        :stroke="color"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie'

interface Props {
  size?: string | number
  strokeWidth?: number
  color?: string
  height?: string
  isLogo?: boolean
}

withDefaults(defineProps<Props>(), {
  height: 'auto',
  isLogo: false,
  strokeWidth: 4,
})
</script>

<style lang="scss" scoped>
.base-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: v-bind(height);

  &__circle {
    animation: rotate 1s linear infinite;
  }

  &__circle-path {
    stroke-dasharray: 125;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 125;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 100, 125;
      stroke-dashoffset: -30;
    }

    100% {
      stroke-dasharray: 1, 125;
      stroke-dashoffset: -125;
    }
  }
}
</style>
